import {
  KnowledgeFavoritePayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createKnowledgeFavoriteMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: KnowledgeFavoritePayload) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(
            `[KnowledgeFavoriteHandler] INSERT KnowledgeFavorite ${item.pageId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgeFavorite,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(
            `[KnowledgeFavoriteHandler] MODIFY KnowledgeFavorite ${item.pageId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgeFavorite,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(
            `[KnowledgeFavoriteHandler] REMOVE KnowledgeFavorite ${item.pageId}`,
          );
          eventEmitter.emit(
            WebSocketEntityType.KnowledgeFavorite,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn(
            '[KnowledgeFavoriteHandler] Unknown action for KnowledgeFavorite:',
            action,
          );
      }
    } catch (error) {
      log.error('[KnowledgeFavoriteHandler] Handler failed:', error);
    }
  };
}
